import React from 'react';
import { getOptionsDeactive } from '../../../utilities/actions/Helpers';
import { SelectBase, Alert } from '../../index';
import { api } from '../../../config/Services';
import { RetrieveRequest } from '../../../utilities/services/RequestService';

class StateSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            isLoading: false
        }
    }

    retrieveData(criteria = {}, inactivefield = {}, actionspage = 'create') {
        let paging = { limit: -1, page: 1 }
        let sort = { statename: 'asc' };
        let url = api.url.masterdata.state.retrieve;
        criteria.active = true;
        let column = [];
        this.setState({ isLoading: true });
        RetrieveRequest(url, criteria, sort, paging, column).then((response) => {
            const { status = {} } = response || {};
            if (status.responsecode === '0000') {
                var options = response.result.map(({ statename, statecode }) => {
                    return {
                        label: statename,
                        value: statecode
                    };
                });

                //if options deactive
                const { statename, statecode } = inactivefield;
                if (statecode) {
                    options = getOptionsDeactive(actionspage, options, statecode, statename);
                }

                this.setState({ options, isLoading: false });
            } else {
                Alert.error(response.status.responsemessage);
            }
        });
    }

    render() {
        return (<SelectBase {...this.props} options={this.state.options} isLoading={this.state.isLoading} />)
    }

}

export default StateSelect;
